export const Referrals = [
    {
        id: 'R001',
        patientId: 1,
        patientLastName: 'Ivanov',
        patientFirstName: 'Ivan',
        patientMiddleName: 'Ivanovich',
        patientAge: 45,
        patientGender: 'Male',
        department: 'Cardiology',
        date: '2024-09-12',
        status: 'Pending',
    },
    {
        id: 'R002',
        patientId: 2,
        patientLastName: 'Petrova',
        patientFirstName: 'Anna',
        patientMiddleName: 'Petrovna',
        patientAge: 34,
        patientGender: 'Female',
        department: 'Neurology',
        date: '2024-09-11',
        status: 'Completed',
    },
    {
        id: 'R003',
        patientId: 3,
        patientLastName: 'Sidorov',
        patientFirstName: 'Sergey',
        patientMiddleName: 'Sidorovich',
        patientAge: 50,
        patientGender: 'Male',
        department: 'Orthopedics',
        date: '2024-09-10',
        status: 'In Progress',
    },
    {
        id: 'R004',
        patientId: 4,
        patientLastName: 'Kuznetsova',
        patientFirstName: 'Elena',
        patientMiddleName: 'Dmitrievna',
        patientAge: 29,
        patientGender: 'Female',
        department: 'Dermatology',
        date: '2024-09-09',
        status: 'Pending',
    },
    {
        id: 'R005',
        patientId: 5,
        patientLastName: 'Volkov',
        patientFirstName: 'Oleg',
        patientMiddleName: 'Nikolaevich',
        patientAge: 40,
        patientGender: 'Male',
        department: 'Oncology',
        date: '2024-09-08',
        status: 'Cancelled',
    },
];
